export const BOOK_INFO = {
  0: [
    {
      id: -1,
      info: [
        {
          type: 'img',
          src: require('@/imgs/index/position/09.png'),
          width: '8rem',
          ani: 'animated1s fadeIn',
        },
      ],
    },
    // {
    //   id: 0,
    //   info: [
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand2-head.png'),
    //       ani: 'animated1s fadeInDown',
    //       mbottom: '4vh',
    //       mtop: '1vh',
    //     },
    //     {
    //       type: 'line',
    //     },
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand2-show.png'),
    //       ani: 'animated0d5s fadeInUp',
    //       mtop: '3.5vh',
    //     },
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand2-word.png'),
    //       ani: 'animated0d5s fadeInDown',
    //       mtop: '3.5vh',
    //     },
    //     {
    //       type: 'img',
    //       width: '6rem',
    //       src: require('@/imgs/index/brand/0.png'),
    //       ani: 'animated0d5s fadeInDown',
    //       mtop: '3.5vh',
    //     },
    //     {
    //       type: 'block',
    //       height: '8vh',
    //     },
    //   ],
    // },
    // {
    //   id: 0,
    //   info: [
    //     {
    //       type: 'img',
    //       width: '7.5rem',
    //       src: require('@/imgs/index/brand/brand3-head.png'),
    //       ani: 'animated1s fadeInDown',
    //       mtop: '1vh',
    //     },
    //     {
    //       type: 'line',
    //     },
    //     {
    //       type: 'img',
    //       width: '7.5rem',
    //       src: require('@/imgs/index/brand/brand3-word.png'),
    //       ani: 'animated0d5s fadeInUp',
    //       mtop: '3.5vh',
    //     },
    //     {
    //       type: 'img',
    //       width: '7.5rem',
    //       src: require('@/imgs/index/brand/brand3-Photo.png'),
    //       ani: 'animated0d5s fadeInDown',
    //       mtop: '3.5vh',
    //     },
    //     {
    //       type: 'img',
    //       width: '3rem',
    //       src: require('@/imgs/index/brand/1.png'),
    //       ani: 'animated0d5s fadeInDown',
    //       mtop: '3.5vh',
    //       mright: '4.5rem',
    //     },
    //     {
    //       type: 'block',
    //       height: '10vh',
    //     },
    //   ],
    // },
    {
      id: 0,
      info: [
        {
          type: 'img',
          width: '7.5rem',
          src: require('@/imgs/index/brand/brand4-head.png'),
          ani: 'animated1s fadeInDown',
          mtop: '1vh',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '7.5rem',
          src: require('@/imgs/index/brand/brand4-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '7.5rem',
          src: require('@/imgs/index/brand/brand4-Photo.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '3rem',
          src: require('@/imgs/index/brand/1.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '3.5vh',
          mright: '4.5rem',
        },
        {
          type: 'block',
          height: '10vh',
        },
      ],
    },
    {
      id: 1,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand5-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/brand5-Photo.png'),
          ani: 'animated1s delay0d5s topTobtm',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '3.4rem',
          src: require('@/imgs/index/brand/brand5-word.png'),
          ani: 'animated0d5s fadeInUp',
          mleft: '4.6rem',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '1vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 2,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand6-head.png'),
          ani: 'animated1s fadeInDown',
        },
        // {
        //   type: 'line',
        // },
        // {
        //   type: 'img',
        //   width: '5rem',
        //   src: require('@/imgs/index/brand/brand6-word.png'),
        //   ani: 'animated0d5s fadeInUp',
        //   mtop: '2vh',
        //   mleft: '-2rem',
        // },
        {
          type: 'img',
          width: '7rem',
          src: require('@/imgs/index/brand/brand6-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '2vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 3,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand7-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand7-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand7-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 4,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand8-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '7rem',
          src: require('@/imgs/index/brand/brand8-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
          mleft: '-1rem',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand8-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 5,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand9-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand9-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '7rem',
          src: require('@/imgs/index/brand/brand9-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
          mleft: '-1rem',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 6,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand10-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand10-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand10-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
    {
      id: 7,
      info: [
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand11-head.png'),
          ani: 'animated1s fadeInDown',
        },
        {
          type: 'line',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand11-Photo.png'),
          ani: 'animated1s delay0d5s fadeIn',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '8rem',
          src: require('@/imgs/index/brand/brand11-word.png'),
          ani: 'animated0d5s fadeInUp',
          mtop: '5vh',
        },
        {
          type: 'img',
          width: '6rem',
          src: require('@/imgs/index/brand/0.png'),
          ani: 'animated0d5s fadeInDown',
          mtop: '2vh',
        },
        {
          type: 'block',
          height: '8vh',
        },
      ],
    },
  ],
  1: [
    // {
    //   id: 1,
    //   info: [
    //   // {
    //   //   type: 'img',
    //   //   width: '8rem',
    //   //   src: require('@/imgs/index/brand/brand1-head.png'),
    //   //   ani: 'animated1s fadeInDown',
    //   // },
    //   // {
    //   //   type: 'line',
    //   // },
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand1-word.png'),
    //       ani: 'animated0d5s fadeInDown',
    //     },
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand1-Photo.png'),
    //       ani: 'animated0d5s fadeIn delay0d5s',
    //     },
    //     {
    //       type: 'img',
    //       width: '8rem',
    //       src: require('@/imgs/index/brand/brand1-show.png'),
    //       ani: 'animated0d5s fadeInUp',
    //     },
    //     {
    //       type: 'block',
    //       height: '8vh',
    //     },
    //   ],
    // },
    {
      id: 0,
      info: [
        {
          type: 'img',
          src: require('@/imgs/index/position/10.png'),
          width: '10rem',
          ani: 'animated1s fadeIn',
        },
      ],
    }],
};

export const NAV_INFO = [
  // {
  //   id: 0,
  //   width: 42,
  //   nWidth: 28,
  //   nIcon: require('@/imgs/index/brand/ywmk_n.png'),
  //   hIcon: require('@/imgs/index/brand/ywmk_h.png'),
  // },
  // {
  //   id: 1,
  //   width: 42,
  //   nWidth: 28,
  //   nIcon: require('@/imgs/index/brand/zzkf_n.png'),
  //   hIcon: require('@/imgs/index/brand/zzkf_h.png'),
  // },
  {
    id: 0,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/zzkf_n.png'),
    hIcon: require('@/imgs/index/brand/zzkf_h.png'),
  },
  {
    id: 1,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/kfxm_n.png'),
    hIcon: require('@/imgs/index/brand/kfxm_h.png'),
  },
  {
    id: 2,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/cyyy_n.png'),
    hIcon: require('@/imgs/index/brand/cyyy_h.png'),
  },
  {
    id: 3,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/czgy_n.png'),
    hIcon: require('@/imgs/index/brand/czgy_h.png'),
  },
  {
    id: 4,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/syyy_n.png'),
    hIcon: require('@/imgs/index/brand/syyy_h.png'),
  },
  {
    id: 5,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/csgx_n.png'),
    hIcon: require('@/imgs/index/brand/csgx_h.png'),
  },
  {
    id: 6,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/wyfw_n.png'),
    hIcon: require('@/imgs/index/brand/wyfw_h.png'),
  },
  {
    id: 7,
    width: 55.3,
    nWidth: 36,
    nIcon: require('@/imgs/index/brand/tsbx_n.png'),
    hIcon: require('@/imgs/index/brand/tsbx_h.png'),
  },
];
